import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';

import YoutubeVideoService from '@/services/YoutubeVideoService';

import AppSwitch from '@/components/ui/AppSwitch.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  channelId: {
    type: String,
    required: true,
  },
  token: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props



const selectedValue = ref<boolean>(false);

const blacklistChannel = async (switchValue: boolean) => {
  if (!switchValue) {
    return;
  }

  const blacklisted = await YoutubeVideoService.banChannel(props.channelId, props.token);

  if (!blacklisted) {
    selectedValue.value = false;
    console.log('Error blacklisting channel');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppSwitch, {
    modelValue: selectedValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedValue).value = $event)),
    label: "Blacklisted",
    variant: "danger",
    onInput: blacklistChannel
  }, null, 8, ["modelValue"]))
}
}

})